// TODO: move to utils folder

// Use hardware acceleration if possible
export function cssTransform(transform) { // eslint-disable-line
  // TODO: check if 3d transforms are supported
  return `${transform} translateZ(0px)`;
}



// WEBPACK FOOTER //
// ./js/utils/css-utils.js